const BRAND_TITLE = 'Gymaholic App: Track Meals and Workouts'
const BRAND_DESCRIPTION = 'Gymaholic is a fitness app that lets you log meals in seconds with AI and follow personalized workout plans built for your goals. Track nutrition and workouts together in one app to stay consistent and see results.'
const BRAND_TAGS = [
  'fitness',
  'motivation',
  'gymaholic',
  'workout',
  'quote',
  'workout app',
  'fitness app',
  'training app'
]
const BRAND_IMAGE = 'https://cdn.gymaholic.co/assets/gymaholic.jpg'
const BRAND_URL = 'https://www.gymaholic.co'

export {
  BRAND_TITLE,
  BRAND_TAGS,
  BRAND_DESCRIPTION,
  BRAND_IMAGE,
  BRAND_URL
}
